import { reactive } from '@vue/composition-api';
import axios from '@/services/axios';


interface Threshold {
    awardList: number[];
}
interface InviteShareInfo {
    result: number,
    data: {
        headUrl: string,
        nickName: string,
        inviteCode: string
        isEnded: boolean, // 助力活动是否结束
        reward: number, // 代表金币或货币的数值
        rewardType: number, // 1: 金币，2: 货币
        unit: string, // 货币单位，rewardType 为 1 时不下发
        threshold: Threshold,
        activityReward: number, // 头图数字
    }
}

interface LandingParams {
    userId: string | (string | null)[],
}

interface InviteShareData {
    result: number,
    headUrl: string,
    nickName: string,
    inviteCode: string,
    awardList: number[],
    reward: number,
    isGolds: boolean,
    unit: string,
    isEnded: boolean,
    activityReward: number,
}

interface MessagesOption {
    path: string,
    country: string,
    language: string
}

interface FishParams {
    fishId: number,
    language: string,
}

interface MaterialInfo {
    name: string,
    desc: string,
    shareCaption: string,
    imageUrl: string,
    h5Style: {
        sharePageType: string,
        pageConfig: object,
    },
};
interface FishInfo {
    id: number,
    content: MaterialInfo
};

interface FishInfoRes {
    result: number,
    data: FishInfo,
};

const inviteShareData = reactive<InviteShareData>({
    result: 0,
    headUrl: '',
    nickName: '',
    inviteCode: '',
    awardList: [],
    reward: 0,
    isGolds: false,
    unit: '',
    isEnded: false,
    activityReward: 0,

});

const fetchData = async (params: LandingParams) => {
    const res: InviteShareInfo = await axios.get('/rest/w/promotion/task/boost/landing', {
        params,
    });
    inviteShareData.result = res.result;
    if (inviteShareData.result === 1) {
        inviteShareData.headUrl = String(res.data?.headUrl ?? '').replace('http:', '');
        inviteShareData.nickName = res.data?.nickName || '';
        inviteShareData.inviteCode = res.data?.inviteCode || '';
        inviteShareData.awardList = res.data?.threshold?.awardList || [];
        inviteShareData.reward = res.data?.reward || 0;
        inviteShareData.isGolds = res.data?.rewardType === 1;
        inviteShareData.unit = res.data?.unit;
        inviteShareData.isEnded = res.data?.isEnded ?? false;
        inviteShareData.activityReward = res.data?.activityReward || 0;
    }
};

export {
    inviteShareData,
    fetchData
};
